module.exports = __webpack_public_path__ + "img/sosmed-youtube.88fdd216.png";